module.exports = __webpack_public_path__ + "static/media/29ADMSPC5.d817c631.jpg";